import { useForm } from "@inertiajs/react";

export default function Login({ errors }: { errors?: Record<string, string> }) {
  const { data, setData, post, processing, transform } = useForm({
    email: "",
    password: "",
    remember: false,
  });

  transform((data) => ({
    user: {
      email: data.email,
      password: data.password,
      remember_me: data.remember,
    },
  }));

  function submit(e: React.FormEvent) {
    e.preventDefault();
    post("/users/sign_in");
  }

  return (
    <div style={{ maxWidth: "400px", margin: "100px auto" }}>
      <h1>Login</h1>
      <form onSubmit={submit}>
        <div style={{ marginBottom: "1rem" }}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={data.email}
            onChange={(e) => setData("email", e.target.value)}
            style={{ width: "100%" }}
          />
          {errors?.email && <div style={{ color: "red" }}>{errors.email}</div>}
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={data.password}
            onChange={(e) => setData("password", e.target.value)}
            style={{ width: "100%" }}
          />
          {errors?.password && (
            <div style={{ color: "red" }}>{errors.password}</div>
          )}
        </div>
        <button
          type="submit"
          disabled={processing}
          style={{ padding: "0.5rem 1rem" }}
        >
          Iniciar Sesión
        </button>
      </form>
    </div>
  );
}
